import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { forwardRef } from 'react';

interface ResourceTypeSelectProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
}

const ResourceTypeSelect = forwardRef((props: ResourceTypeSelectProps, _ref) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Allocation Type
      </InputLabel>
      <Select
        id="filter-resourceType"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        size="small"
        value={props?.value}
        onChange={(e) => props?.onChange(e)}
      >
        <MenuItem key="Billable" value="Billable">Billable</MenuItem>
        <MenuItem key="Non-Billable" value="Non-Billable">
          Non-Billable
        </MenuItem>
        <MenuItem value="Shadow">Shadow</MenuItem>
        <MenuItem value="Support">Support</MenuItem>
        <MenuItem value="T&M">T&M</MenuItem>
      </Select>
    </FormControl>
  );
});

export default ResourceTypeSelect;
